<template>
	<ActivityLayout class="goal-kr-creation-activity">
		<template #badge>
			<NewItemActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				name: activity.name,
				changedBy: activity.changedBy,
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import NewItemActivityBadge from "../Activity/NewItemActivityBadge.vue";

export default {
	name: "GoalKRCreationActivity",
	components: {
		ActivityLayout,
		NewItemActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, name:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKRCreationActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
